/**
 * @generated SignedSource<<b25ad6854354446452f6301f6e48e5d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListSectionHeaderTeam_Team$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "ListSectionHeaderTeam_Team";
};
export type ListSectionHeaderTeam_Team$key = {
  readonly " $data"?: ListSectionHeaderTeam_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListSectionHeaderTeam_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListSectionHeaderTeam_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "13783f8458f9f99d22db2f9af14f8858";

export default node;
